import ApplicationController from "./application_controller";

export default class extends ApplicationController {

  static targets = [ 'startTime', 'interactionType', 'title', 'recipient' ]

  setToday(event) {
    event.preventDefault();
    const today = new Date();
    today.setHours(today.getHours() + 1);
    this.startTimeTarget._flatpickr.setDate(today);
  }

  setTomorrow(event) {
    event.preventDefault();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.startTimeTarget._flatpickr.setDate(tomorrow);
  }

  setNextWeek(event) {
    event.preventDefault();
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 7);
    this.startTimeTarget._flatpickr.setDate(nextWeek);
  }

  setNextMonth(event) {
    event.preventDefault();
    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    this.startTimeTarget._flatpickr.setDate(nextMonth);
  }

  setInteractionType(event) {
    // when interactionType is set, update the Title to
    // reflect the interactionType
    const interactionType = event.target.value;
    const title = this.titleTarget.value;
    // interactiontype mit applicant name
    const recipient = this.recipientTarget.value;
    this.titleTarget.value = `${interactionType} mit ${recipient}`;
  }

  preventSubmit(event) {
    // Verhindert das automatische Absenden des Formulars bei Datum-Änderungen
    event.preventDefault();
    event.stopPropagation();
  }
}
